// Exports
export default {
	"oneColLayout": "oneColLayout_tAzfs"
};
